import React, { useState } from "react";
import { Button, ButtonGroup, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { ModeEdit } from "@mui/icons-material";

export const HardwareIdEditor: React.FunctionComponent<HardwareIdEditorProp> = (props) => {
    const {t} = useTranslation();
    const [isEditing, setIsEditing] = useState(false);
    const [editedValue, setEditedValue] = useState(props.value);

    const handleEditToggle = () => {
        setIsEditing(!isEditing);
        if (!isEditing) {
            setEditedValue(props.value);
        }
    };

    const handleOk = () => {
        props.setValue(editedValue);
        setIsEditing(false);
    };

    return (
        <Stack spacing={1}>
            <Typography variant="h6">
                {t("Hardware ID")}
            </Typography>

            {isEditing ? (
                <Stack direction="row" spacing={1} sx={{alignItems: "center"}}>
                    <TextField
                        label={t("Hardware ID")}
                        InputProps={{
                            inputProps: {maxLength: 65535}
                        }}
                        maxRows={1}
                        style={{width: '400px'}}
                        value={editedValue}
                        onChange={(ev) => {
                            setEditedValue(ev.target.value);
                        }}/>
                    <ButtonGroup>
                        <Button variant="outlined" onClick={handleOk}>
                            {t("Ok")}
                        </Button>
                        <Button variant="outlined" onClick={handleEditToggle}>
                            {t("Cancel")}
                        </Button>
                    </ButtonGroup>
                </Stack>
            ) : (
                <Stack direction="row" spacing={1} sx={{alignItems: "center"}}>
                    <TextField
                        label={t("Hardware ID")}
                        contentEditable={false}
                        maxRows={1}
                        InputProps={{
                            readOnly: true,
                            inputProps: {maxLength: 65535}
                        }}
                        style={{width: '400px'}}
                        value={props.value}>
                    </TextField>
                    <IconButton aria-label="copy hardware id"
                                title={t("Copy hardware ID")}
                                onClick={async () => await navigator.clipboard.writeText(props.value)}>
                        <ContentCopyIcon/>
                    </IconButton>
                    <IconButton title={t("Edit hardware ID")} onClick={handleEditToggle}>
                        <ModeEdit/>
                    </IconButton>
                </Stack>
            )}
        </Stack>
    );
};

export interface HardwareIdEditorProp {
    value: string;
    setValue: (newValue: string) => void;
}